import type { TooltipProps } from 'recharts'
import { brand, formatNumber } from '../theme'
import { isDerivedIncomplete, isIncompletePoint, missingDays, missingDaysText } from './partial'

// Ink-surfaced tooltip, Jost, soft corners — matches the brand, not default recharts.
export function CustomTooltip({ active, payload, label, labels, formatValue = formatNumber }: TooltipProps<number, string> & {
  labels?: Record<string, string>
  formatValue?: (value: number) => string
}) {
  if (!active || !payload || payload.length === 0) return null
  const point = payload[0]?.payload
  const periodFrom = point?.period_from
  const periodTo = point?.period_to
  return (
    <div
      style={{
        background: brand.tealDark,
        color: '#fff',
        fontFamily: brand.font,
        fontSize: 13,
        fontVariantNumeric: 'tabular-nums',
        padding: '8px 12px',
        borderRadius: 'var(--radius-1)',
        boxShadow: 'var(--shadow-1)',
      }}
    >
      {label !== undefined && (
        <div style={{ opacity: 0.7, marginBottom: 2 }}>{labels?.[String(label)] ?? String(label)}</div>
      )}
      {typeof periodFrom === 'string' && typeof periodTo === 'string' && (
        <div style={{ opacity: 0.85, marginBottom: 4 }}>
          {isDerivedIncomplete(point) ? 'Includes incomplete periods · '
            : isIncompletePoint(point) ? `Incomplete · ${missingDaysText(missingDays(point))} · ` : ''}
          {point?.period_kind === 'partial' ? 'Partial period · ' : ''}{periodFrom} – {periodTo}
        </div>
      )}
      {payload.map((p, i) => (
        <div key={i} style={{ fontWeight: 600 }}>
          {labels?.[String(p.name)] ?? p.name}: {typeof p.value === 'number' ? formatValue(p.value) : p.value}
        </div>
      ))}
    </div>
  )
}
